import React, { useState, useEffect } from "react";
import { Select, Form, Button, Input, message } from "antd";
import { LinkOutlined } from "@ant-design/icons";
// import SettingUrl from "../json-connector-url-setting";
import SettingUrl from "./setting";
import { ApiRun } from "../../../host";

export default function FormUrl({
  setRaw,
  url,
  setUrl,
  loading,
  setLoading,
  setParam,
  Loading,
}) {
  const [method, setMethod] = useState("GET");
  const [dataSend, setDataSend] = useState([]);
  const [btnActive, setBtnActive] = useState(true);
  const options = [
    { value: "GET", label: "GET" },
    { value: "POST", label: "POST" },
  ];
  const [data, setData] = useState([
    { categorie: "HEADERS", donnees: [], selected: true },
    { categorie: "FORMDATA", donnees: [], selected: false },
    { categorie: "FORMURL", donnees: [], selected: false },
    { categorie: "RAW", donnees: [], selected: false, type: "json" },
  ]);
  const getCategorie = ({ categorie, type }) => {
    if (categorie === "FORMDATA") return "form-data";
    else if (categorie === "FORMURL") return "x-www-form-urlencoded";
    else return type.toLocaleLowerCase() === "json" ? "json" : "plain";
  };
  const getContent = ({ donnees }) => {
    if (typeof donnees !== "string") {
      const content = {};
      for (let index = 0; index < donnees.length; index++) {
        const key = donnees[index].name;
        const value = donnees[index].value;
        if (key !== "") {
          content[key] = value;
        }
      }
      return content;
    } else {
      return donnees;
    }
  };
  // const getHeader = (headers, categorie) => {};
  useEffect(() => {
    const newData = data.filter(({ selected }) => selected);
    setDataSend(newData);
  }, [data]);

  const onFinish = (e) => {
    setLoading(true);
    Loading(true);
    const dataHeaders = dataSend[0];

    const headers = {};
    for (let index = 0; index < dataHeaders.donnees.length; index++) {
      const key = dataHeaders.donnees[index].name;
      const value = dataHeaders.donnees[index].value;
      if (key !== "") {
        headers[key] = value;
      }
    }

    const Body = dataSend[1] ? dataSend[1] : null;

    const options = {
      url: url,
      method: method.toLocaleLowerCase(),
      contentType: Body ? getCategorie(Body).toLocaleLowerCase() : null,
      content: Body ? getContent(Body) : null,
      headers: headers,
    };
    // console.log(options);
    const raw = JSON.stringify(options);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    fetch(ApiRun, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        setParam(options);
        setRaw(JSON.parse(result).data);
        Loading(false);
      })
      .catch((error) => {
        message.error(
          "une erreur est survenue lors de l'insertion des données"
        );
        Loading(false);
        console.log("error", error);
      });
  };

  return (
    <Form
      name="basic"
      labelCol={{ span: 8 }}
      onFinish={onFinish}
      style={{ maxWidth: "100%" }}
      initialValues={{ remember: true }}
      autoComplete="off"
    >
      <Input.Group compact>
        <Select
          defaultValue={options[0].value}
          defaultActiveFirstOption
          onChange={setMethod}
          options={options}
          style={{ width: "25%" }}
        />

        <Input
          type="url"
          prefix={<LinkOutlined />}
          allowClear
          style={{ width: "55%", textAlign: "left" }}
          placeholder="Enter request URL"
          value={url}
          onChange={(value) => {
            value.target.value === ""
              ? setBtnActive(true)
              : setBtnActive(false);
            setUrl(value.target.value);
          }}
          required
        />

        <Button
          type="primary"
          style={{ width: "20%" }}
          htmlType="submit"
          disabled={btnActive}
        >
          Lancer
        </Button>
      </Input.Group>
      <SettingUrl data={data} updateData={setData} />
    </Form>
  );
}
